import { useRouterSelector } from '~/hooks/useRouterSelector';
import { getSavedFilterIdFromPath } from '~/utils/PathUtils';

export const useSavedFilterIdSelector = () => {
  return useRouterSelector((location) => getSavedFilterIdFromPath(location.pathname));
};
